export default __webpack_public_path__ + "static/media/schema-bg-smd.34e739b0.svg";